<template>
  <v-container fluid>
    <v-row align-content="space-around">
      <v-col cols="12">
        <v-card outlined>
          <v-card-title>Time based mqtt commands</v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-form ref="form" v-model="valid">
              <v-radio-group
                row
                v-model="deviceType"
                label="Device Type : "
                :rules="rules"
              >
                <v-radio label="Ecotron" value="ecotron"></v-radio>
                <v-radio label="Ecofrost" value="ecofrost"></v-radio>
              </v-radio-group>
              <v-datetime-picker
                label="Schedule Time"
                v-model="scheduleTimestamp"
                :dateFormat="dateFormat"
                :timeFormat="timeFormat"
                :date-picker-props="dateProps"
                :time-picker-props="timeProps"
                :text-field-props="textFieldProps"
              >
                <template slot="dateIcon">
                  <v-icon> mdi-calendar </v-icon>
                </template>
                <template slot="timeIcon">
                  <v-icon>mdi-alarm</v-icon>
                </template>
              </v-datetime-picker>
              <div v-if="deviceType === 'ecotron'">
                <v-textarea
                  outlined
                  label="MQTT Command"
                  placeholder=" "
                  rounded
                  no-resize
                  :rules="rules"
                  v-model="command"
                  :rows="3"
                ></v-textarea>
                <v-textarea
                  outlined
                  label="Device Serial Numbers"
                  placeholder="Comma Seperated Serial Numbers Eg: EZMCI19120358,EZMCI19120359,EZMCI19120360"
                  auto-grow
                  :rules="rules"
                  v-model="listOfDeviceIds"
                  rounded
                ></v-textarea>
              </div>
              <div v-else-if="deviceType === 'ecofrost'">
                <v-textarea
                  outlined
                  label="MQTT Command"
                  placeholder="Command Format should be parameter1:value1;parameter2:value2 For Eg: HRM:ECOFROST V3;Set_T:5;Set_H:92"
                  rounded
                  no-resize
                  :rules="rules"
                  v-model="command"
                  :rows="3"
                ></v-textarea>
                <v-text-field
                  outlined
                  label="Device Serial Numbers"
                  placeholder="Single device For Eg: E011912A001"
                  auto-grow
                  :rules="rules"
                  v-model="listOfDeviceIds"
                  rounded
                ></v-text-field>
              </div>
            </v-form>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer />
            <v-btn color="primary" @click="scheduleJob" :loading="loading">
              <v-icon left>mdi-clock-outline</v-icon>
              Schedule Time Job
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row align-content="space-around">
      <v-col cols="12">
        <v-card outlined>
          <v-card-title>List of time based jobs</v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-card outlined>
              <v-data-table :headers="headers" :items="items">
                <template #[`item.deleteAction`]="{ item }">
                  <v-btn
                    fab
                    small
                    text
                    color="red"
                    :disabled="
                      user.email !== 'alok@ecozensolutions.com' &&
                      user.email !== 'samir@ecozensolutions.com' &&
                      user.email !== item.created_by
                    "
                  >
                    <v-icon small @click="deleteRecord(item)">
                      mdi-delete
                    </v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-card>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="refreshResult">
              <v-icon left>mdi-restore</v-icon>
              Refresh
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

const schedulerApi = axios.create({
  baseURL: 'https://api.ecozen.ai/scheduler/v1'
});

export default {
  name: 'time-based-mqtt',
  data() {
    return {
      valid: true,
      deviceType: null,
      rules: [value => !!value || 'Required'],
      listOfDeviceIds: '',
      loading: false,
      command: '',
      scheduleTimestamp: null,
      dateFormat: 'dd/MM/yy',
      timeFormat: 'HH:mm',
      dateProps: {
        color: 'primary',
        min: moment().toISOString()
      },
      timeProps: {
        format: '24hr',
        color: 'primary'
      },
      textFieldProps: {
        prependIcon: 'mdi-calendar',
        rules: [value => !!value || 'Required'],
        outlined: true,
        rounded: true,
        placeHolder: ' '
      },
      headers: [
        {
          text: 'Device Type',
          value: 'machine_type',
          sortable: false
        },
        {
          text: 'Mqtt Command',
          value: 'mqtt_command',
          sortable: false
        },
        {
          text: 'Device(s)',
          value: 'list_of_machine_id',
          sortable: false
        },
        {
          text: 'Scheduled Timestamp',
          value: 'scheduled_timestamp',
          sortable: false
        },
        {
          text: 'Completion Timestamp',
          value: 'completion_timestamp',
          sortable: false
        },
        {
          text: 'Status',
          value: 'job_status',
          sortable: false
        },
        {
          text: 'Created By',
          value: 'created_by',
          sortable: false
        },
        {
          text: 'Error/Remarks',
          value: 'remarks',
          sortable: false
        },
        {
          text: 'Created At',
          value: 'created_at',
          sortable: false
        },
        {
          text: 'Delete',
          value: 'deleteAction',
          sortable: false
        }
      ],
      items: []
    };
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    }
  },
  methods: {
    async scheduleJob() {
      this.loading = true;
      this.$store.commit('setError', false);
      try {
        if (this.$refs.form.validate()) {
          if (this.deviceType === 'ecotron') {
            const response = await schedulerApi.post('/mqtt/ecotron', {
              listOfMachineIds: this.listOfDeviceIds.split(','),
              mqttCommand: this.command,
              scheduledTimestamp: this.scheduleTimestamp.toISOString(),
              createdBy: this.user.email
            });
            this.items = response.data.listOfJobs;
          } else if (this.deviceType === 'ecofrost') {
            const response = await schedulerApi.post('/mqtt/ecofrost', {
              machineId: this.listOfDeviceIds,
              mqttCommand: this.command,
              scheduledTimestamp: this.scheduleTimestamp.toISOString(),
              createdBy: this.user.email
            });
            this.items = response.data.listOfJobs;
          }
        }
      } catch (error) {
        if (error.isAxiosError) {
          this.$store.commit('setError', error.response.data.error.message);
        } else {
          this.$store.commit('setError', error);
        }
      } finally {
        this.loading = false;
        this.$refs.form.reset();
      }
    },
    async refreshResult() {
      this.$store.commit('setError', false);
      try {
        const response = await schedulerApi.get('/mqtt');
        this.items = response.data;
      } catch (error) {
        if (error.isAxiosError) {
          this.$store.commit('setError', error.response.data.error.message);
        } else {
          this.$store.commit('setError', error);
        }
      }
    },
    async deleteRecord(payload) {
      this.$store.commit('setError', false);
      try {
        const response = await schedulerApi.delete('/mqtt', {
          params: { time_id: payload.id }
        });
        this.items = response.data;
      } catch (error) {
        if (error.isAxiosError) {
          this.$store.commit('setError', error.response.data.error.message);
        } else {
          this.$store.commit('setError', error);
        }
      }
    }
  },
  async created() {
    await this.refreshResult();
  }
};
</script>

<style></style>
